package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class ProjectQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    organization_id: String,
    objective_id: String?,
    name: String,
    description: String?,
    objectives: String?,
    color: String,
    icon: String,
    skill_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-754_707_382, arrayOf("project"), driver, "Project.sq", "selectAll",
      "SELECT project.id, project.organization_id, project.objective_id, project.name, project.description, project.objectives, project.color, project.icon, project.skill_id, project.order_index, project.created_at, project.updated_at, project.is_deleted, project.deleted_at, project.synced_at FROM project WHERE is_deleted = 0 ORDER BY order_index, name") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectAll(): Query<Project> = selectAll { id, organization_id, objective_id, name,
      description, objectives, color, icon, skill_id, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Project(
      id,
      organization_id,
      objective_id,
      name,
      description,
      objectives,
      color,
      icon,
      skill_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByOrganization(organization_id: String, mapper: (
    id: String,
    organization_id: String,
    objective_id: String?,
    name: String,
    description: String?,
    objectives: String?,
    color: String,
    icon: String,
    skill_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByOrganizationQuery(organization_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectByOrganization(organization_id: String): Query<Project> =
      selectByOrganization(organization_id) { id, organization_id_, objective_id, name, description,
      objectives, color, icon, skill_id, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Project(
      id,
      organization_id_,
      objective_id,
      name,
      description,
      objectives,
      color,
      icon,
      skill_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByObjective(objective_id: String?, mapper: (
    id: String,
    organization_id: String,
    objective_id: String?,
    name: String,
    description: String?,
    objectives: String?,
    color: String,
    icon: String,
    skill_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByObjectiveQuery(objective_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectByObjective(objective_id: String?): Query<Project> =
      selectByObjective(objective_id) { id, organization_id, objective_id_, name, description,
      objectives, color, icon, skill_id, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Project(
      id,
      organization_id,
      objective_id_,
      name,
      description,
      objectives,
      color,
      icon,
      skill_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    organization_id: String,
    objective_id: String?,
    name: String,
    description: String?,
    objectives: String?,
    color: String,
    icon: String,
    skill_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectById(id: String): Query<Project> = selectById(id) { id_, organization_id,
      objective_id, name, description, objectives, color, icon, skill_id, order_index, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Project(
      id_,
      organization_id,
      objective_id,
      name,
      description,
      objectives,
      color,
      icon,
      skill_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    organization_id: String,
    objective_id: String?,
    name: String,
    description: String?,
    objectives: String?,
    color: String,
    icon: String,
    skill_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(578_369_595, arrayOf("project"), driver, "Project.sq", "selectDirty",
      "SELECT project.id, project.organization_id, project.objective_id, project.name, project.description, project.objectives, project.color, project.icon, project.skill_id, project.order_index, project.created_at, project.updated_at, project.is_deleted, project.deleted_at, project.synced_at FROM project WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectDirty(): Query<Project> = selectDirty { id, organization_id, objective_id, name,
      description, objectives, color, icon, skill_id, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Project(
      id,
      organization_id,
      objective_id,
      name,
      description,
      objectives,
      color,
      icon,
      skill_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    organization_id: String,
    objective_id: String?,
    name: String,
    description: String?,
    objectives: String?,
    color: String,
    icon: String,
    skill_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getString(7)!!,
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13),
      cursor.getLong(14)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Project> = selectByIdAnyState(id) { id_,
      organization_id, objective_id, name, description, objectives, color, icon, skill_id,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Project(
      id_,
      organization_id,
      objective_id,
      name,
      description,
      objectives,
      color,
      icon,
      skill_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    organization_id: String,
    objective_id: String?,
    name: String,
    description: String?,
    objectives: String?,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-1_121_478_764, """
        |INSERT INTO project(id, organization_id, objective_id, name, description, objectives, color, icon, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 11) {
          bindString(0, id)
          bindString(1, organization_id)
          bindString(2, objective_id)
          bindString(3, name)
          bindString(4, description)
          bindString(5, objectives)
          bindString(6, color)
          bindString(7, icon)
          bindLong(8, order_index)
          bindLong(9, created_at)
          bindLong(10, updated_at)
        }
    notifyQueries(-1_121_478_764) { emit ->
      emit("project")
    }
  }

  public fun update(
    organization_id: String,
    objective_id: String?,
    name: String,
    description: String?,
    objectives: String?,
    color: String,
    icon: String,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-776_532_572, """
        |UPDATE project
        |SET organization_id = ?, objective_id = ?, name = ?, description = ?, objectives = ?, color = ?, icon = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 10) {
          bindString(0, organization_id)
          bindString(1, objective_id)
          bindString(2, name)
          bindString(3, description)
          bindString(4, objectives)
          bindString(5, color)
          bindString(6, icon)
          bindLong(7, order_index)
          bindLong(8, updated_at)
          bindString(9, id)
        }
    notifyQueries(-776_532_572) { emit ->
      emit("project")
    }
  }

  public fun linkObjective(
    objective_id: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-719_875_804,
        """UPDATE project SET objective_id = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, objective_id)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-719_875_804) { emit ->
      emit("project")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-860_156_464,
        """UPDATE project SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-860_156_464) { emit ->
      emit("project")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-1_265_723_117,
        """UPDATE project SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""", 2)
        {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-1_265_723_117) { emit ->
      emit("project")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(-1_040_218_671, """DELETE FROM project WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(-1_040_218_671) { emit ->
      emit("project")
      emit("projectStatus")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(342_737_154,
        """UPDATE project SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(342_737_154) { emit ->
      emit("project")
    }
  }

  public fun updateSkill(
    skill_id: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-196_627_699, """UPDATE project SET skill_id = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindString(0, skill_id)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-196_627_699) { emit ->
      emit("project")
    }
  }

  public fun setSkill(skill_id: String?, id: String) {
    driver.execute(1_158_124_842, """UPDATE project SET skill_id = ? WHERE id = ?""", 2) {
          bindString(0, skill_id)
          bindString(1, id)
        }
    notifyQueries(1_158_124_842) { emit ->
      emit("project")
    }
  }

  private inner class SelectByOrganizationQuery<out T : Any>(
    public val organization_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("project", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("project", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(207_934_689,
        """SELECT project.id, project.organization_id, project.objective_id, project.name, project.description, project.objectives, project.color, project.icon, project.skill_id, project.order_index, project.created_at, project.updated_at, project.is_deleted, project.deleted_at, project.synced_at FROM project WHERE organization_id = ? AND is_deleted = 0 ORDER BY order_index, name""",
        mapper, 1) {
      bindString(0, organization_id)
    }

    override fun toString(): String = "Project.sq:selectByOrganization"
  }

  private inner class SelectByObjectiveQuery<out T : Any>(
    public val objective_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("project", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("project", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null,
        """SELECT project.id, project.organization_id, project.objective_id, project.name, project.description, project.objectives, project.color, project.icon, project.skill_id, project.order_index, project.created_at, project.updated_at, project.is_deleted, project.deleted_at, project.synced_at FROM project WHERE objective_id ${ if (objective_id == null) "IS" else "=" } ? AND is_deleted = 0 ORDER BY order_index, name""",
        mapper, 1) {
      bindString(0, objective_id)
    }

    override fun toString(): String = "Project.sq:selectByObjective"
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("project", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("project", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_921_051_063,
        """SELECT project.id, project.organization_id, project.objective_id, project.name, project.description, project.objectives, project.color, project.icon, project.skill_id, project.order_index, project.created_at, project.updated_at, project.is_deleted, project.deleted_at, project.synced_at FROM project WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Project.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("project", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("project", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_243_033_746,
        """SELECT project.id, project.organization_id, project.objective_id, project.name, project.description, project.objectives, project.color, project.icon, project.skill_id, project.order_index, project.created_at, project.updated_at, project.is_deleted, project.deleted_at, project.synced_at FROM project WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Project.sq:selectByIdAnyState"
  }
}
